module.exports = __webpack_public_path__ + "img/图片6.22461eb5.png";